
import SelectedListProps from './mixins/SelectedListProps';
import { OptionProperty, SelectedListProperty, SelectedListEventType } from './enums';
import { StyleSizeType, StyleColorSchemeType } from '../../../../../styles/enums';
import Button from '../../../../button';
import { ButtonFillType, ButtonProperty, ButtonPropsEventType } from '../../../../button/enums';
import Icon from '../../../../icon';
import { IconType, IconProperty } from '../../../../icon/enums';

export default {
  name: 'SelectSelectedList',
  components: {
    Button,
    Icon,
  },
  mixins: [SelectedListProps],
  data() {
    return {
      SelectedListProperty,
      ButtonProperty,
      ButtonFillType,
      ButtonPropsEventType,
      StyleColorSchemeType,
      IconType,
      IconProperty,
      StyleSizeType,
    };
  },
  computed: {
    valueOptions() {
      if (Array.isArray(this[SelectedListProperty.Value])) {
        return this[SelectedListProperty.Value]
          .map((value) => this.getOptionByValue(value))
          .filter(Boolean);
      }

      return [];
    },
  },
  methods: {
    getOptionByValue(value) {
      return this[SelectedListProperty.Options]
        .find((option) => option[OptionProperty.Value] === value);
    },
    handleRemoveOptionClick(value) {
      this.$emit(SelectedListEventType.RemoveOption, value);
    },
  },
};
